import React from 'react';
import PropTypes from 'prop-types';
import ArrowBack from '@material-ui/icons/ChevronLeft';
import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import SmallCenteredPaper from 'components/templates/SmallCenteredPaper';
import LoginStepOne from './LoginStepOne';
import LoginStepTwo from './LoginStepTwo';
import LoginStepThree from './LoginStepThree';

const LoginComponent = ({
  login,
  resetForm,
  resetPassword,
  submitStepOne,
  submitStepTwo,
  submitStepThree,
  requestedToken,
  requestedResetPassword,
  loading,
}) => {
  const {
    inProgress,
    type,
    userType,
    usernameHaveBeenChecked,
    username,
    errors,
  } = login;

  if (requestedResetPassword) {
    return (
      <SmallCenteredPaper
        after={(
          <Button href="/dashboard/login">
            <ArrowBack />
            <FormattedMessage
              id="welcome.backTo"
              defaultMessage="Back to the main page"
            />
          </Button>
        )}
      >
        <Alert severity="success" elevation={3}>
          <FormattedMessage
            id="passwordreset.sent"
            defaultMessage="We have sent you an email with instructions to reset your password"
          />
        </Alert>
      </SmallCenteredPaper>
    );
  }

  return (
    <SmallCenteredPaper
      after={usernameHaveBeenChecked ? (
        <Button onClick={resetForm}>
          <ArrowBack />
          <FormattedMessage
            id="welcome.changeEmail"
            defaultMessage="Change email"
          />
        </Button>
      ) : (
        <Button href="/">
          <ArrowBack />
          <FormattedMessage
            id="welcome.backTo"
            defaultMessage="Back to the main page"
          />
        </Button>
      )}
    >
      {
        // first step where you put username
        !usernameHaveBeenChecked && (
          <LoginStepOne
            inProgress={inProgress}
            onSubmit={submitStepOne}
            error={errors}
          />
        )
      }
      {
        // second step when you put password if user exists or create a new user if it doesnt
        usernameHaveBeenChecked && type !== 'SOFT' && (
          <LoginStepTwo
            username={username}
            userType={userType}
            onSubmit={submitStepTwo}
            resetPassword={resetPassword}
            error={errors}
            loading={loading}
          />
        )
      }
      {
        // third step when you have a soft user and request a login token
        usernameHaveBeenChecked && type === 'SOFT' && (
          <LoginStepThree
            onClick={submitStepThree}
            requestedToken={requestedToken}
            username={username}
          />
        )
      }
    </SmallCenteredPaper>
  );
};

LoginComponent.propTypes = {
  login: PropTypes.shape({
    inProgress: PropTypes.bool,
    type: PropTypes.oneOf(['SOFT', 'STRICT']),
    userType: PropTypes.bool,
    usernameHaveBeenChecked: PropTypes.bool,
    username: PropTypes.string,
    errors: PropTypes.shape({}),
  }),
  resetForm: PropTypes.func,
  resetPassword: PropTypes.func,
  submitStepOne: PropTypes.func,
  submitStepTwo: PropTypes.func,
  submitStepThree: PropTypes.func.isRequired,
  requestedToken: PropTypes.bool.isRequired,
  requestedResetPassword: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
};

export default LoginComponent;
